<script lang="ts">
  /**
   * "A new version is ready" — shown only to a signed-in user, because a signed-out page
   * reloads itself (nothing to lose there). Deliberately a banner and not a toast: a toast
   * disappears after a few seconds, and someone in the middle of a message should be able to
   * finish it and take the update when they are ready.
   */
  import { t } from '$lib/i18n';
  import { appUpdate } from '$lib/pwa.svelte';
</script>

{#if appUpdate.ready}
  <div class="bar" role="status">
    <span>{t('updateReady')}</span>
    <button type="button" class="apply" onclick={() => appUpdate.apply()}>{t('updateNow')}</button>
    <button type="button" class="later" onclick={() => appUpdate.dismiss()}>{t('updateLater')}</button>
  </div>
{/if}

<style>
  /* @css shell/UpdateBanner start */
  .bar {
    position: fixed;
    inset-inline: 0;
    top: 0;
    z-index: 60;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 10px 16px calc(10px + env(safe-area-inset-top));
    font-size: 13px;
    color: var(--text-on-accent, #fff);
    background: var(--blue-600);
    box-shadow: var(--shadow-md);
  }
  button {
    font: inherit;
    font-weight: 600;
    border: 0;
    border-radius: var(--radius-control);
    padding: 6px 12px;
    cursor: pointer;
  }
  .apply {
    color: var(--blue-700);
    background: #fff;
  }
  .later {
    color: inherit;
    background: rgba(255, 255, 255, 0.16);
  }
  /* @css shell/UpdateBanner end */
</style>
